<template>
  <div class="buy-panel-product-info">
    <span :class="['buy-panel-product-info-model', { 'tmall': isModelPriceLabelPositionCentered && isFavoritesOnly || isModelPriceLabelPositionCentered && checkUGC & !tmallIsUGCMS }]">
      {{ name }}
    </span>
    <span class="buy-panel-product-info-price" v-if="(isModelPriceLabelPositionCentered && !isFavoritesOnly || !isModelPriceLabelPositionCentered)">
      <currency-wrapper :priceRaw="$store.state.buyPanel.price.string" />
    </span>
  </div>
</template>

<script>

import currencyWrapper from '@/components/Globals/CurrencyWrapper'

export default {
  name: "productInfo",
  components: {
    currencyWrapper
  },
  props: {
    productName:{
      type: String,
      default: ""
    },
    isModelPriceLabelPositionCentered:{
      type: Boolean,
      default: false
    },
    isFavoritesOnly: {
      type: Boolean,
      default: false
    },
    tmallIsUGCMS: {
      type: Boolean,
      default: false
    },
    checkUGC: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    name() {
      const { utils } = this.$store.state;
      return utils.pdm ? utils.pdm.product_name : this.productName;
    }
  }
}
</script>
